var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgDHeatingValveGrouplevel = function SvgDHeatingValveGrouplevel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 684 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 684,
    height: 480,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 592.05,
    y: 102.01,
    width: 28,
    height: 10,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 605.05,
    y: 97.01,
    width: 2,
    height: 10
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "592.55 99.87 605.04 107 592.56 114.15 592.55 99.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.05,100.73l10.98,6.26-10.97,6.29v-12.55M592.05,99.01v16s14-8.01,14-8.01l-14-7.98h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "607.06 107 619.54 99.87 619.55 114.15 607.06 107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.04,100.73v12.55s-10.98-6.29-10.98-6.29l10.98-6.26M620.04,99.01l-13.99,7.98,14,8.01v-16h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 606.05,
    cy: 86.02,
    r: 11,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.05,76.02c5.51,0,10,4.48,10,10s-4.49,10-10,10-10-4.48-10-10,4.49-10,10-10M606.05,75.02c-6.08,0-11,4.92-11,11s4.92,11,11,11,11-4.92,11-11-4.92-11-11-11h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M608.97,82.67v5.69h-.98v-1.87s.1-2.5.1-2.5l-1.68,4.38h-.71s-1.68-4.38-1.68-4.38l.1,2.51v1.87h-.98v-5.69h1.28s1.64,4.36,1.64,4.36l1.64-4.36h1.28Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 606.05,
    cy: 106.99,
    r: 5,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.05,102.99c2.21,0,4,1.79,4,4s-1.79,4-4,4-4-1.79-4-4,1.79-4,4-4M606.05,101.99c-2.76,0-5,2.24-5,5s2.24,5,5,5,5-2.24,5-5-2.24-5-5-5h0Z"
  }))))));
};
export default SvgDHeatingValveGrouplevel;